(ns practitest.frontend.landing.last-actions
  (:require [practitest.frontend.components2.container-card :refer [container-card]]
            [practitest.frontend.components2.pagination :refer [pagination-view]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.format-utils :refer [formatted-local-date]]
            [practitest.frontend.components.overflow :refer [overflow-with-mux-tooltip]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.landing.subs :as landing-subs]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))

(defn build-entity-url
  "Build entity URL from entity type, id, and project id"
  [entity-type entity-id project-id]
  (when (and entity-type entity-id project-id)
    (let [path (case entity-type
                 "Test" "tests"
                 "Requirement" "requirements"
                 "Issue" "issues"
                 "TestSet" "sets"
                 "Instance" "instances"
                 "Run" "qtest_runs"
                 "Milestone" "milestones"
                 nil)]
      (when path
        (str "/p/" project-id "/" path "/" entity-id "/edit")))))

(defn split-actions
  "Split log into individual actions"
  [log]
  (when log
    (->> (clojure.string/split log #";")
         (map clojure.string/trim)
         (filter seq))))

(defn history-item-card [{:keys [history expanded-ids toggle-expanded]}]
  (let [{:keys [id log created_at entity_type entity_display_id entity_title entity_id project_id project_name actions_count]} history
        entity-url (build-entity-url entity_type entity_id project_id)
        has-multiple-actions? (and actions_count (> actions_count 1))
        split-actions (split-actions log)
        first-action (first split-actions)
        is-expanded? (contains? expanded-ids id)]
    [:div.similar-items-cards-container
     [:div.similar-item-card
      [:div.traceability-card-row.first-row
       [:div.history-content
        (when (and entity_type entity_display_id entity_title)
          [:div.entity-type-text.entity-title-row
           entity_type " # " entity_display_id " "
           [overflow-with-mux-tooltip
            {}
            (fn [props]
              [:a.name-with-link.ellipsis (merge {:href entity-url
                                                   :target "_blank"} props)
               entity_title])
            entity_title]])
        [:div.entity-type-text
         "Project: " project_name]
        [:div.entity-type-text
         (if is-expanded?
           [:div.actions-list
            (for [[idx action] (map-indexed vector split-actions)]
              ^{:key idx}
              [overflow-with-mux-tooltip {}
               (fn [props]
                 [:div.action-item (merge props {:class "action-item-overflow"}) action])
               action])]
           [overflow-with-mux-tooltip {}
            (fn [props]
              [:div.first-action-overflow (or props {}) first-action])
            first-action])]]
       [:span.timestamp-holder
        (formatted-local-date created_at)]]
      (when (and has-multiple-actions? (not is-expanded?))
        [:div.more-actions-wrapper
         [:a.more-actions-link
          {:on-click #(toggle-expanded id)}
          (str (get-translation "entity.form.view-more" "View More") " (" (dec actions_count) ")")]])
      (when (and has-multiple-actions? is-expanded?)
        [:div.more-actions-wrapper
         [:a.more-actions-link
          {:on-click #(toggle-expanded id)}
          (get-translation "entity.form.view-less" "View Less")]])]]))

(defn pagination-controls []
  (let [current-page @(re-frame/subscribe [:landing/histories-page])
        total-histories @(re-frame/subscribe [:landing/total-histories])]
    [pagination-view
     {:on-change #(re-frame/dispatch [:landing/change-histories-page %])
      :current-page current-page
      :total-count total-histories
      :per-page landing-subs/histories-per-page
      :max-buttons 0
      :always-show-nav? true}]))

(defn last-actions []
  (let [expanded-ids (r/atom #{})]
    (fn []
      (let [histories @(re-frame/subscribe [:landing/histories])
            ;; Deref expanded-ids here to track changes and trigger re-renders
            current-expanded @expanded-ids]
        [:div.pt-section
         [:div.pt-container-card-header
          [:div
           [:h3.pt-container-card-title [icons/mux-action-clock] (get-translation "landing.last-actions" "Last Actions")]
           [:p.pt-container-card-subtitle (get-translation "landing.last-actions.subtitle" "Your 40 Last Actions")]]
          [pagination-controls]]
         [container-card
          {:class "pt-last-actions-card"}

          [:div.pt-last-actions
          (if (empty? histories)
            [:div.no-items
             (get-translation "landing.last-actions.empty" "No recent actions")]
            (for [history histories]
              [:div {:key (:id history)}
               [history-item-card
                {:history history
                 :expanded-ids current-expanded
                 :toggle-expanded (fn [id]
                                    (swap! expanded-ids
                                           (fn [ids]
                                             (if (contains? ids id)
                                               (disj ids id)
                                               (conj ids id)))))}]]))]]]))))
